module.exports = __webpack_public_path__ + "fonts/HalisR-Book.94e1b1ca.otf";